module.exports = __webpack_public_path__ + "img/wirecard.d96bedca.svg";